import { useCallback } from 'react';

import { loanApplicationSignalRConnection } from 'app/services/signalR';
import _ from 'lodash';

import { PresenceSignalRMessageType } from 'constants/presence';
import useLoanId from 'hooks/useLoanId';
import { logger } from 'utils/logger';

const useRevertFieldValues = () => {
  const loanId = useLoanId();

  const revertFieldValues = useCallback(
    fieldPaths => {
      if (!loanId || _.isNil(fieldPaths) || !fieldPaths.length) {
        return;
      }

      const normalizedPaths = fieldPaths.map(fp => fp?.toLowerCase());

      loanApplicationSignalRConnection
        .invoke(PresenceSignalRMessageType.REVERT_FIELD_VALUES, loanId, ...normalizedPaths)
        .catch(err => {
          logger.error('Failed to broadcast revert field values', {
            loanId,
            fieldPaths: normalizedPaths,
            err,
          });
        });
    },
    [loanId],
  );

  return revertFieldValues;
};

export default useRevertFieldValues;
